import isNumber from 'lodash/isNumber'
import { SHORT_MONTHS } from './date'

const asDecimalCache = []

function formatIfNumber(format) {
  return input => (isNumber(input) ? format(input) : input)
}

export function asFullYear(date) {
  return date.getFullYear()
}

export function asDecimal(precision) {
  const key = `${precision}`

  if (!asDecimalCache[key]) {
    asDecimalCache[key] = formatIfNumber(n => {
      const formatted = n.toFixed(precision)
      return formatted == -0 ? (0.0).toFixed(precision) : formatted
    })
  }

  return asDecimalCache[key]
}

export function asPercent(n) {
  return `${n * 100}%`
}

export function asDecimalPercent(precision, { scale = 100 } = {}) {
  return formatIfNumber(n => {
    const formatted = asDecimal(precision)(n * scale)

    if (formatted == -0) {
      return (0.0).toFixed(precision) + '%'
    }

    return `${formatted}%`
  })
}

export function asWholeNumber(input) {
  return formatIfNumber(n => Math.round(n))(input)
}

export function asWholePercent(input) {
  return formatIfNumber(n => asWholeNumber(n * 100) + '%')(input)
}

export function asWholePercentGTOne(input) {
  return formatIfNumber(n => {
    const percentage = n * 100
    return percentage < 1 ? '< 1%' : asWholePercent(n)
  })(input)
}

export function asPercentileText(input) {
  return formatIfNumber(n => {
    const wholePercentNumber = asWholeNumber(n * 100)
    return `${asOrdinal(wholePercentNumber)} percentile`
  })(input)
}

export function asOrdinal(input) {
  return formatIfNumber(n => {
    const suffixes = ['th', 'st', 'nd', 'rd']
    const mod = n % 100
    return n + (suffixes[(mod - 20) % 10] || suffixes[mod] || suffixes[0])
  })(input)
}

export function asBillions(input) {
  return formatIfNumber(n => {
    let rounded = n < 1 ? asDecimal(2)(n) : asWholeNumber(n)
    return `$${rounded}B`
  })(input)
}

export function asShortMonth(date) {
  return SHORT_MONTHS[date.getMonth()]
}

export function toFixed(value, precision) {
  return Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision)
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/format.js